import React, { useState } from "react";
import { db } from "../../../firebase";
import { doc, updateDoc, arrayUnion } from "firebase/firestore";
import styles from "./VideoUploadForm.module.css";

const VideoUploadForm = ({ companyId, videos, setVideos }) => {
  const [category, setCategory] = useState("ceoMessage");
  const [videoUrl, setVideoUrl] = useState("");
  const [message, setMessage] = useState("");

  // 유튜브 URL을 embed URL 형식으로 변환하는 함수
  const convertToEmbedURL = (url) => {
    const videoIdMatch = url.match(
      /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/))([^?&]+)/ // 유튜브 ID 추출
    );
    return videoIdMatch
      ? `https://www.youtube.com/embed/${videoIdMatch[1]}`
      : null;
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!videoUrl.trim()) {
      setMessage("⚠️ 유효한 유튜브 URL을 입력하세요!");
      return;
    }

    const embedURL = convertToEmbedURL(videoUrl);
    if (!embedURL) {
      setMessage("❌ 올바른 유튜브 URL을 입력하세요.");
      return;
    }

    if (!companyId) {
      setMessage("❌ 회사 ID가 존재하지 않습니다.");
      return;
    }

    try {
      const companyRef = doc(db, "companies", companyId);
      await updateDoc(companyRef, {
        [`videos.${category}`]: arrayUnion(embedURL), // Firestore에 추가
      });

      // 즉시 반영: 기존 videos 상태 업데이트
      setVideos((prevVideos) => ({
        ...prevVideos,
        [category]: prevVideos[category]
          ? [...prevVideos[category], embedURL]
          : [embedURL],
      }));

      setMessage("✅ 영상이 등록되었습니다!");
      setVideoUrl("");
    } catch (error) {
      console.error("❌ Firestore 업데이트 실패:", error);
      setMessage(`❌ 등록 실패: ${error.message}`);
    }
  };

  return (
    <div className={styles.container}>
      <h2>영상 등록</h2>
      <form onSubmit={handleUpload} className={styles.form}>
        <label>카테고리 선택</label>
        <select value={category} onChange={(e) => setCategory(e.target.value)}>
          <option value="ceoMessage">CEO Message</option>
          <option value="videoClip">Video Clip</option>
        </select>

        <label>유튜브 영상 URL</label>
        <input
          type="text"
          placeholder="https://youtu.be/..."
          value={videoUrl}
          onChange={(e) => setVideoUrl(e.target.value)}
          required
        />

        <button type="submit">등록</button>
      </form>

      {message && <p className={styles.message}>{message}</p>}
    </div>
  );
};

export default VideoUploadForm;
